const { APP_REBOOT, SCENE_TRANSITION, MODAL_ENABLE, MODAL_DISABLE, STAGE_CLEAR, GAME_OVER, GAME_PAUSE, GAME_RESUME, GAME_CLEAR, } = require("./actions");
const { sceneType, modalType } = require('../define/screenType').default;

// ============================

const initialState = {
    scene: sceneType.SCENE_TITLE,
    modal: modalType.MODAL_DISABLE
};

const enableModal = (state, type) => {
    if (state.modal === modalType.MODAL_DISABLE) {
        state.modal = type;
    }
    return state;
}

export function screenState(state = initialState, action) {
    // console.log(`# screenState: ${JSON.stringify(state)} -> ${JSON.stringify(action)}`);
    switch (action.type) {
        case APP_REBOOT:
            return initialState;
        case SCENE_TRANSITION:
            return {
                ...state,
                scene: action.scene,
                modal: modalType.MODAL_DISABLE
            };
        case MODAL_ENABLE:
            return enableModal({ ...state }, action.modal);
        case MODAL_DISABLE:
            return {
                ...state,
                modal: modalType.MODAL_DISABLE
            };
        case STAGE_CLEAR:
            return enableModal({ ...state }, modalType.MODAL_STAGE_CLAER);
        case GAME_CLEAR:
            return enableModal({ ...state }, modalType.MODAL_GAME_CLEAR);
        case GAME_OVER:
            return enableModal({ ...state }, modalType.MODAL_GAME_OVER);
        case GAME_PAUSE:
            return enableModal({ ...state }, modalType.MODAL_GAME_PAUSE);
        case GAME_RESUME:
            return {
                ...state,
                modal: modalType.MODAL_DISABLE
            };
        default:
            return state;
    }
}


